import { render, staticRenderFns } from "./alluserlist_OfficersView.vue?vue&type=template&id=a98a181c"
import script from "./alluserlist_OfficersView.vue?vue&type=script&lang=js"
export * from "./alluserlist_OfficersView.vue?vue&type=script&lang=js"
import style0 from "./alluserlist_OfficersView.vue?vue&type=style&index=0&id=a98a181c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports